import { render, staticRenderFns } from "./Neo4jReportView.vue?vue&type=template&id=2c0043a6&scoped=true"
import script from "./Neo4jReportView.vue?vue&type=script&lang=js"
export * from "./Neo4jReportView.vue?vue&type=script&lang=js"
import style0 from "./Neo4jReportView.vue?vue&type=style&index=0&id=2c0043a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0043a6",
  null
  
)

export default component.exports